/*@ngInject*/
const QuoteRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getQuote = function (quoteId) {
        var url = '/rest/Quote/' + quoteId;

        return this.get(url);
    };

    this.deleteQuoteListRegistration = function (submissionId) {
        var url = '/rest/Quote/List?registrationIdentifier=/SubmissionQuotes/' + submissionId;

        return this.delete(url);
    };
};

angular.module('gw-um-submission')
    .service('quoteRepository', QuoteRepository);
